module.exports = __webpack_public_path__ + "img/Symbol orange.827a4a66.png";